import type { InvitationPreview } from "../../lib/api-modules/types.js";

/**
 * Renders the invitation context above the SignUpForm in invitation-
 * accept mode. Shows household name, role, who invited, and expiry.
 */
export function InvitationPreviewCard({ preview }: { preview: InvitationPreview }) {
  const expires = new Date(preview.expires_at);
  return (
    <div className="rounded-lg border border-brand-100 bg-brand-50/50 p-4 text-sm dark:border-brand-700/40 dark:bg-brand-700/10">
      <p className="font-medium text-brand-700 dark:text-brand-100">
        You're joining {preview.household_name}
      </p>
      <p className="mt-1 text-zinc-700 dark:text-zinc-300">
        Role: <span className="font-medium capitalize">{preview.role}</span> ·
        Invited by{" "}
        <span className="font-medium">{preview.inviter_display_name}</span>
      </p>
      <p className="mt-1 text-xs text-zinc-500 dark:text-zinc-400">
        Invitation expires {expires.toLocaleDateString()} at{" "}
        {expires.toLocaleTimeString()}
      </p>
    </div>
  );
}
